/**
 * 카카오 로그인 (OAuth Authorization Code 방식).
 *
 *  흐름: Login 버튼 → kakaoAuthorizeUrl() 로 이동 → 카카오 인증 →
 *        /oauth/kakao 로 ?code= 콜백 → 백엔드(/auth/kakao)가 code+secret 으로 토큰 교환 → 자체 JWT 발급.
 *
 *  - client_id = REST API 키 (REACT_APP_KAKAO_REST_KEY)
 *  - redirect_uri 는 현재 origin 기준으로 동적 생성 → dev(localhost:3000)/운영 도메인 모두 동작.
 *    ⚠️ 여기서 만든 redirect_uri 가 카카오 콘솔 "리다이렉트 URI" 목록에 등록돼 있어야 함(미등록 시 KOE006).
 *  - Client Secret 은 프론트에 두지 않는다(백엔드 전용).
 */
export const KAKAO_REST_KEY = process.env.REACT_APP_KAKAO_REST_KEY;
export const KAKAO_REDIRECT_PATH = "/oauth/kakao";

/** 현재 접속 origin 기준 redirect_uri (콘솔 등록값과 일치해야 함) */
export const kakaoRedirectUri = () => window.location.origin + KAKAO_REDIRECT_PATH;

/**
 * 카카오 인증 페이지 URL.
 * @param {string} [state] 로그인 후 돌아갈 경로(redirect). 콜백에서 그대로 복원해 이동.
 */
export const kakaoAuthorizeUrl = (state) => {
  const params = new URLSearchParams({
    client_id: KAKAO_REST_KEY,
    redirect_uri: kakaoRedirectUri(),
    response_type: "code",
  });
  if (state) params.set("state", state);
  return `https://kauth.kakao.com/oauth/authorize?${params.toString()}`;
};
